import CryptoJS from 'crypto-js'

const key = CryptoJS.enc.Utf8.parse('0A16637D1F33869B') // 16位
// const iv = CryptoJS.enc.Utf8.parse('0A16637D1F33869B')

export const encrypt = (word) => {
  let encrypted = ''
  if (typeof word === 'string') {
    const srcs = CryptoJS.enc.Utf8.parse(word)
    encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
  } else if (typeof word === 'object') {
    // 对象格式的转成json字符串
    const data = JSON.stringify(word)
    const srcs = CryptoJS.enc.Utf8.parse(data)
    encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
  } else {
    console.log('encrypt error')
    return
  }
  return encrypted.ciphertext.toString()
}

export const decrypt = (word) => {
  const encryptedHexStr = CryptoJS.enc.Hex.parse(word)
  const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
  const decrypt = CryptoJS.AES.decrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })

  let decrypted = decrypt.toString(CryptoJS.enc.Utf8)

  return JSON.parse(decrypted)
}

export const mdcrypt = (word) => {
  return CryptoJS.MD5(word).toString()
}



// WEBPACK FOOTER //
// ./src/utils/crypto.js